(function () {
  if (window.__blueminum_collection_ran) return;
  window.__blueminum_collection_ran = true;

  function boot() {
    try { initQuickAdd(); }   catch (e) { console.error('[Blueminum] QuickAdd init:', e); }
    try { initSortSubmit(); } catch (e) { console.error('[Blueminum] Sort init:', e); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // ==== Quick Add ====
  function initQuickAdd() {
    document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        handleQuickAdd(btn);
      });
    });
  }

  function handleQuickAdd(btn) {
    if (btn.classList.contains('is-adding') || btn.classList.contains('is-added')) return;
    if (btn.disabled) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) {
      console.warn('[Blueminum] Quick-add missing variant id');
      return;
    }

    btn.classList.add('is-adding');
    setBtnIcon(btn, 'spinner');

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('sections', 'cart-drawer-section,cart-drawer,cart-icon-bubble,cart-notification,cart-live-region-text,header');
    formData.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      cache: 'no-store',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (addResponse) {
        if (addResponse && addResponse.sections) {
          applySections(addResponse.sections);
        }
        return fetch('/cart.js', {
          cache: 'no-store',
          headers: { 'Accept': 'application/json' }
        });
      })
      .then(function (res) { return res ? res.json() : null; })
      .then(function (cart) {
        if (cart) updateCartCount(cart);

        btn.classList.remove('is-adding');
        btn.classList.add('is-added');
        setBtnIcon(btn, 'check');

        setTimeout(function () {
          btn.classList.remove('is-added');
          setBtnIcon(btn, 'plus');
        }, 1800);
      })
      .catch(function (err) {
        console.error('[Blueminum] Quick-add error:', err);
        btn.classList.remove('is-adding');
        setBtnIcon(btn, 'plus');
      });
  }

  function setBtnIcon(btn, kind) {
    if (kind === 'plus') {
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>';
    } else if (kind === 'check') {
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';
    } else if (kind === 'spinner') {
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9" opacity="0.3"/><path d="M12 3a9 9 0 0 1 9 9"><animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.9s" repeatCount="indefinite"/></path></svg>';
    }
  }

  function applySections(sections) {
    for (const name in sections) {
      const html = sections[name];
      if (!html) continue;
      const target = document.getElementById('shopify-section-' + name);
      if (!target) continue;
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const wrapper = doc.body.firstElementChild;
        target.innerHTML = wrapper ? wrapper.innerHTML : html;
      } catch (e) {
        console.warn('[Blueminum] Failed to apply section ' + name + ':', e);
      }
    }
  }

  function updateCartCount(cart) {
    const count = cart.item_count;

    // Legacy selectors
    const selectors = [
      '[data-cart-count]',
      '.cart-count-bubble',
      '.cart-count',
      '.header__cart-count',
      '.cart-link__bubble',
      '.cart-link__count',
      '.site-header__cart-count',
      '[ref="cartBubbleCount"]'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (node) {
        if (node.children.length !== 0) return;
        node.textContent = count;
        if (count > 0) {
          node.removeAttribute('hidden');
          node.classList.remove('hidden', 'visually-hidden');
        }
      });
    });

    // Save to session storage (Savor bfcache)
    try {
      sessionStorage.setItem('cart-count', JSON.stringify({
        value: String(count),
        timestamp: Date.now()
      }));
    } catch (e) {}

    // Dispatch the standard cart event Savor's cart-icon and cart-drawer listen for
    const cartUpdatePromise = Promise.resolve({
      cart: { totalQuantity: count, id: cart.token, items: cart.items || [] },
      detail: { itemCount: count, didError: false }
    });
    ['cart:update', 'cart:lines:update', 'cart-lines-update', 'cartLinesUpdate'].forEach(function (name) {
      const evt = new Event(name, { bubbles: true, composed: true });
      evt.action = 'add';
      evt.promise = cartUpdatePromise;
      document.dispatchEvent(evt);
    });

    // Generic events for other themes
    ['cart:updated', 'cart:build', 'theme:cart:change'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { detail: cart, bubbles: true }));
    });
  }

  // ==== Sort dropdown ====
  function initSortSubmit() {
    document.querySelectorAll('[data-sort-form]').forEach(function (form) {
      const select = form.querySelector('select');
      if (!select) return;
      select.addEventListener('change', function () {
        form.submit();
      });
    });
  }
})();